var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_15906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7399 56.32L53.4199 57.32L69.7999 72.38L72.3599 69.24C74.6399 66.43 74.4199 62.35 71.8299 59.81L65.3299 53.43C61.5999 49.77 55.3299 51.34 53.7499 56.31L53.7399 56.32Z",
    fill: "#EC5569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3701 54.73C43.4101 54.73 53.1801 44.97 53.1801 32.92C53.1801 20.87 43.4201 11.11 31.3701 11.11C19.3201 11.11 9.56006 20.87 9.56006 32.92C9.56006 42.17 15.3101 50.07 23.4401 53.24",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23 48.78L51.2 52.75",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3599 51.59L50.0399 53.91C48.4899 55.46 48.4899 57.97 50.0399 59.52L59.4699 68.95C60.5199 70 61.9499 70.59 63.4299 70.59C66.5299 70.59 69.0399 68.08 69.0399 64.98C69.0399 63.49 68.4499 62.07 67.3999 61.02L57.9699 51.59C56.4199 50.04 53.9099 50.04 52.3599 51.59Z",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_15906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.6e829000ebe1dc2d5c5e2601e339a14b.svg";
export { ForwardRef as ReactComponent };